import http from "./public";
// 登陆
export const userLogin = (params) => {
  return http.fetchPost("/customer/auth/login", params);
};
// 退出登陆
export const loginOut = (params) => {
  return http.fetchDelt("/customer/auth/logout", params);
};
// 用户信息
// export const userInfo = (params) => {
//   return http.fetchGet('/member/checkLogin', params)
// }
// 注册账号
export const register = (params) => {
  return http.fetchPost("/customer/auth/register", params);
};
//重置密码
export const reset = (params) => {
  return http.fetchPost("/front/user/pwd/reset", params);
};
//发短信验证码
export const sendCode = (params) => {
  return http.fetchPost("/front/user/code/send", params);
};
// // 上传图片
// export const upload = (params) => {
//   return http.fetchPost("/member/imgaeUpload", params);
// };
// // 修改头像
// export const updateheadimage = (params) => {
//   return http.fetchPost("/member/updateheadimage", params);
// };
// // 捐赠列表
// export const thanksList = (params) => {
//   return http.fetchGet("/member/thanks", params);
// };

// 首页接口
// export const getBanner = (params) => {
//   return http.fetchGet("/api/home", params);
// };
// // 首页接口
// export const productHome = (params) => {
//   return http.fetchGet("/api/banner", params);
// };

// export const getAbout = () => {
//   return http.fetchGet("/api/article/about");
// };

// // 首页接口
// export const getProductDetail = (params) => {
//   return http.fetchGet("/api/product/public/" + params);
// };
// // 首页接口
// export const navList = (params) => {
//   return http.fetchGet("/goods/navList", params);
// };

// 首页接口
export const allProducts = (params) => {
  return http.fetchPost("/front/web/cup", params);
};
/**
 * 建盏模糊查询
 * @param {查询关键词} params
 * @returns
 */
export const search = (params) => {
  return http.fetchPost("/front/web/cup", params);
};
// 文章列表接口
export const allArticles = (params) => {
  return http.fetchPost("/front/web/article", params);
};
// 通过id获取文章
export const articleById = (id) => {
  return http.fetchGet(`/front/web/article/${id}`);
};
// 通过文章id获取活动信息
export const getActivityByArticleId = (id) => {
  return http.fetchGet(`/front/web/activity/${id}`);
};
// 报名活动
export const signUpForActivity = (params) => {
  return http.fetchPost(`/front/web/signUpActivity`, params);
};

export const allMaster = (params) => {
  return http.fetchPost("/front/web/master", params);
};

export const masterById = (id) => {
  return http.fetchGet(`/front/web/master/${id}`);
};

// // 首页接口
// export const articleByClass = (params) => {
//   return http.fetchGet(`/api/article/public/query`, params);
// };

export const recommendArticle = (params) => {
  return http.fetchGet("/api/article/public/recommend", params);
};
// // 捐赠板块
// export const thank = (params) => {
//   return http.fetchGet("/goods/thank", params);
// };
// // 极验验证码
// export const geetest = (params) => {
//   return http.fetchGet("/member/geetestInit?t=" + new Date().getTime(), params);
// };

// 查询建盏列表
export const getAllTraceProduct = (params) => {
  return http.fetchPost("/front/web/cup", params);
};
// 查询系列盏
export const getAllSeriesProduct = (params) => {
  return http.fetchPost("/front/app/series/seriesPageList", params);
};
// 查询套装盏
export const getAllSuitProduct = (params) => {
  return http.fetchPost("/front/app/appSuitList", params);
};
// 查询套装盏
export const getSuitProductById = (params) => {
  return http.fetchPost("front/app/suit/infoById", params);
};
// 通过追溯码查询建盏
export const getProductByTraceCode = (params) => {
  return http.fetchPost("/front/web/trace/code", params);
};
// 获取数组字典
export const getDicts = (id) => {
  return http.fetchGet(`/front/web/dict/${id}`);
};
// export const getTraceProductDetail = (params) => {
//   return http.fetchGet("/api/product/trace/detail?traceCode=" + params);
// };
// 查询公司列表
export const getAllCompany = (params) => {
  return http.fetchPost("/front/web/company", params);
};

// 查询公司列表
export const getHistoryRecord = (params) => {
  return http.fetchGet("/api/product/history", params);
};

export const getAppAddress = () => {
  return http.fetchGet("/front/web/appQrCode");
};
export const getApp = () => {
  return http.fetchGet("/front/web/appAddress");
};
// 查询评论列表
export const getCommentList = (params) => {
  return http.fetchPost("/front/web/commentList", params);
};
// 发表评论
export const addComment = (params) => {
  return http.fetchPost("/front/web/addComment", params);
};
export const getPlateList = () => {
  return http.fetchGet("/front/web/plateList");
};
export const getPostList = (params) => {
  return http.fetchPost("/front/web/getPostList", params);
};
// 发帖
export const createPost = (params) => {
  return http.fetchPost("/front/web/createPostApprove", params);
};

import Vue from 'vue';
export const addBrowseRecord = (params) => {
  return http.fetchPost("/beacon/jzBrowseRecord/add", params);
};




// WEBPACK FOOTER //
// ./src/api/index.js